import { render, staticRenderFns } from "./OrdersHistoric.vue?vue&type=template&id=02a96bd2"
import script from "./OrdersHistoric.vue?vue&type=script&lang=js"
export * from "./OrdersHistoric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports